import React, { useCallback, useContext, useEffect, useState } from "react";
import DataLoading from "../components/DataLoading";
import { UserContext } from "../components/UserContext";
import axiosInstance from "../helper/axios";
import Pager from "react-pager";
import Trans from "../helper/Trans";
const attApi = axiosInstance;

function Notifications(props) {
  const { setTitle, setOperation, setPLink } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [annData, setAnnData] = useState([]);
  const [pager, setPager] = useState({ current: 0, total: 0, pageCount: 0 });
  const handlePageChanged = (newPage) => {
    getData(newPage + 1);
  };

  function createMarkup(html) {
    return { __html: html };
  }
  const getData = useCallback((page) => {
    setLoading(true);
    attApi
      .get("/notifications?page=" + page)
      .then((res) => {
        if (res.status === 200) {
          setAnnData(res.data.data);
          setPager(res.data.pager);
          setLoading(false);
          props.setNotiCount(res.data.notiCount);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  },[props]);

  useEffect(() => {
    setTitle("Notifications");
    setOperation("Notifications");
    setPLink("");
  }, [setTitle, setOperation, setPLink]);
  useEffect(() => {
    getData(0);
  }, [getData]);

  return (
    <div>
      {loading ? (
        <DataLoading />
      ) : (
        <>
          {pager.total === 0 ? (
            <p>{Trans("No Data found")}</p>
          ) : (
            <p>
              {Trans("Showing") +
                " " +
                ((pager.current + 1) * 20 - 19) +
                "-" +
                (pager.total < (pager.current + 1) * 20
                  ? pager.total
                  : (pager.current + 1) * 20) +
                " " +
                Trans("of") +
                " " +
                pager.total +
                " " +
                Trans("notifications")}
              .
            </p>
          )}
          {Object.keys(annData).map(function (key) {
            let d = annData[key];
            return (
              <div className="item" key={key}>
                <div className="ul-widget-s7__items mb-4">
                  <div className="ul-widget-s7__item-circle">
                    <p
                      className={
                        "ul-vertical-line " +
                        (key % 2 === 0 ? "bg-primary" : "bg-success")
                      }
                    ></p>
                  </div>
                  <div className="ul-widget-s7__item-text">
                    <span>{d.msgAt}</span>
                    <br />
                    <span>
                     <b dangerouslySetInnerHTML={createMarkup(d.title)} ></b>
                    </span>
                    <p>{d.body}</p>
                    <span>{d.msgBy}</span>
                  </div>
                </div>
              </div>
            );
          })}
          {pager.pageCount <= 1 ? (
            <></>
          ) : (
            <Pager
              total={pager.pageCount}
              current={pager.current}
              visiblePages={10}
              titles={{ first: "First", last: "Last" }}
              className="pagination-sm"
              onPageChanged={handlePageChanged}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Notifications;
